module.exports = __webpack_public_path__ + "img/JOC_3649.72ad484b.jpg";